<header>
    <h1 class="title">Debug Menu</h1>
    <h2 class="subtitle">Chapps Manager v{{ APP_VERSION }}</h2>
</header>

<main>

<section>
    <h3>Language switcher</h3>
    <p>Allows to change the UI language on the fly. (Note this does not affect the language of anything generated on the
        backend</p>
    <chapps-primary-button (click)="openLanguageSwitcher()"
                           [small]="true"
                           label="Open"></chapps-primary-button>
</section>

<section>
    <h3>System status</h3>
    <p>
        <strong>Polling interval – </strong>the rate at which the system status is refreshed from the backend
    </p>
    <pre>{{ pollingInterval | number }}ms</pre>

    <p>
        <strong>Log Status – </strong>logs the current System Status to the console for inspection
    </p>
    <chapps-primary-button (click)="logSystemStatus()"
                           [small]="true"
                           label="Log Status"></chapps-primary-button>

    <p>
        <strong>Force refresh – </strong>force a refresh of the System Status instead of waiting for the next interval
    </p>
    <chapps-primary-button (click)="refreshSystemStatus()"
                           [small]="true"
                           label="Refresh"></chapps-primary-button>
</section>

    <section>
        <h3>Environment</h3>

        <p>
            <strong>Production – </strong>
            is the current environment a production environment
        </p>
        <pre>{{ isDevMode ? '🟢 No' : '🔴 Yes'}}</pre>

        <p><strong>Log environment – </strong> logs the current environment settings to the console for inspection</p>
        <chapps-primary-button (click)="logEnvironment()"
                               [small]="true"
                               label="Log environment"></chapps-primary-button>


        <!--
            Currently disabled due to how JWT tokens are set as cookies on the domain.
            Switching to Development will redirect to account-dev but the JWT cookie
            will be set on chapps.com. So it won't be available on chapps.local
            causing so it will just redirect to account-dev because the app
            does not consider you to be logged in.
        -->
        <!--       <p><strong>Change environment – </strong>changes to another environment</p>
               <app-env-selector (envChanged)="applyEnvironment($event)"></app-env-selector>-->
    </section>

    <section>
        <h3>API</h3>


        <p><strong>Log API endpoints – </strong> logs all API endpoints to the console. This will take any changes in
            the environment into account</p>
        <chapps-primary-button (click)="logAPIEndoint()"
                               [small]="true"
                               label="Log Endpoints"></chapps-primary-button>
    </section>

    <section>
        <h3>Permissions</h3>


        <p><strong>Log permissions – </strong> logs the permissions as received by the backend</p>
        <chapps-primary-button (click)="logPermissions()"
                               [small]="true"
                               label="Log Permissions"></chapps-primary-button>
    </section>

    <section>
        <h3>Token</h3>


        <p><strong>Dump token – </strong> decrypt and dump token</p>
        <chapps-primary-button (click)="dumpToken()"
                               [small]="true"
                               label="Dump"></chapps-primary-button>
    </section>

</main>
